import formValidation from "util/formValidation";
import { ApiV1Base, ApiPrefix, statusCheck, json, getCookie } from "util/icwUtility";
import { actLoginTimedOut } from "./loginStateActions";

export const ANY_FIELD_UPDATE = "ANY_FIELD_UPDATE";
export function actAnyFieldUpdate(storeName, accessPath, newVal) {
    return { type: ANY_FIELD_UPDATE, storeName, accessPath, newVal };
}

export const ANY_FIELD_ADD = "ANY_FIELD_ADD";
export function actAnyFieldAdd(storeName, accessPath, newObj) {
    return { type: ANY_FIELD_ADD, storeName, accessPath, newObj };
}

export const ANY_FIELD_REMOVE = "ANY_FIELD_REMOVE";
export function actAnyFieldRemove(storeName, accessPath) {
    return { type: ANY_FIELD_REMOVE, storeName, accessPath };
}

export const CLONE_OBJECT = "CLONE_OBJECT";
export function actCloneObject(storeName, accessPath, idx) {
    return { type: CLONE_OBJECT, storeName, accessPath, idx };
}

export function updatedObject(obj, accessPath, value) {
    const [k, ...rest] = accessPath;

    if (typeof k === "number") {
        if (accessPath.length === 1) {
            return [...obj.slice(0, k), value, ...obj.slice(k + 1)];
        }

        return [...obj.slice(0, k), updatedObject(obj[k], [...rest], value), ...obj.slice(k + 1)];
    }
    if (accessPath.length === 1) {
        return { ...obj, [k]: value };
    }
    return { ...obj, [k]: updatedObject(obj[k], [...rest], value) };
}

export function addNestedFields(obj, accessPath, targetObj) {
    const [k, ...rest] = accessPath;
    if (typeof k === "number") {
        if (accessPath.length === 1) {
            return [...obj.slice(0, k), targetObj, ...obj.slice(k + 1)];
        }
        return [
            ...obj.slice(0, k),
            addNestedFields(obj[k], [...rest], targetObj),
            ...obj.slice(k + 1),
        ];
    }
    if (accessPath.length === 1) {
        return { ...obj, [k]: [...obj[k], targetObj] };
    }
    return { ...obj, [k]: addNestedFields(obj[k], [...rest], targetObj) };
}

export function removeNestedFields(obj, accessPath) {
    const [k, ...rest] = accessPath;
    if (typeof k === "number") {
        if (accessPath.length === 1) {
            return obj.filter((i, idx) => idx !== k);
        }
        return [...obj.slice(0, k), removeNestedFields(obj[k], [...rest]), ...obj.slice(k + 1)];
    }
    if (accessPath.length === 1) {
        const { [k]: removeKey, ...objRest } = obj;
        return Object.assign({}, objRest);
    }
    return { ...obj, [k]: removeNestedFields(obj[k], [...rest]) };
}

export function getObject(obj, accessPath, idx) {
    let res = obj;
    accessPath.forEach(k => {
        res = res[k];
    });
    return res[idx];
}

export function getValue(obj, accessPath) {
    let res = obj || null;

    accessPath.forEach(k => {
        if (res == null || typeof res[k] === "undefined") res = null;
        else res = res[k];
    });

    return res;
}

//  ******* Validation *******
export const VALIDATE_BEGIN = "VALIDATE_BEGIN";
function actValidateBegin(storeName) {
    return { type: VALIDATE_BEGIN, storeName };
}

export const VALIDATE_SUCCESS = "VALIDATE_SUCCESS";
function actValidateSuccess(storeName) {
    return { type: VALIDATE_SUCCESS, storeName };
}

export const VALIDATE_ERROR = "VALIDATE_ERROR";
function actValidateError(storeName, errors) {
    return { type: VALIDATE_ERROR, storeName, errors };
}

export function actValidate(storeName, schema, data) {
    return dispatch => {
        dispatch(actValidateBegin(storeName));
        return formValidation(schema, data)
            .then(() => dispatch(actValidateSuccess(storeName)))
            .catch(errors => dispatch(actValidateError(storeName, errors.inner)));
    };
}

//
//  Non-scalable functions. Pending to migrate
//

export const FORMFIELD_UPDATE = "FORMFIELD_UPDATE";
export function actFormFieldUpdate(storeName, fieldName, newVal) {
    return { type: FORMFIELD_UPDATE, storeName, fieldName, newVal };
}

export const SUBFIELD_UPDATE = "SUBFIELD_UPDATE";
export function actSubFieldUpdate(storeName, fieldName, idx, subFieldName, newVal) {
    return { type: SUBFIELD_UPDATE, storeName, fieldName, idx, subFieldName, newVal };
}

export const LEVEL_3_SUBFIELD_UPDATE = "LEVEL_3_SUBFIELD_UPDATE";
export function actLevel3SubFieldUpdate(
    storeName,
    fieldName,
    idx,
    subFieldName,
    subIdx,
    level3SubFieldName,
    newVal
) {
    return {
        type: LEVEL_3_SUBFIELD_UPDATE,
        storeName,
        fieldName,
        idx,
        subFieldName,
        subIdx,
        level3SubFieldName,
        newVal,
    };
}

export const PULLDOWNFIELD_UPDATE = "PULLDOWNFIELD_UPDATE";
export function actPullDownFieldUpdate(storeName, fieldName, newVal, title) {
    return { type: PULLDOWNFIELD_UPDATE, storeName, fieldName, newVal, title };
}

export const NESTED_RECORD_ADD = "NESTED_RECORD_ADD";
export function actNestedRecordAdd(storeName, fieldName) {
    return { type: NESTED_RECORD_ADD, storeName, fieldName };
}

export const NESTED_RECORD_REMOVE = "NESTED_RECORD_REMOVE";
export function actNestedRecordRemove(storeName, fieldName, idx) {
    return { type: NESTED_RECORD_REMOVE, storeName, fieldName, idx };
}

export const MODIFY_DROPZONE = "MODIFY_DROPZONE";
export function actInspectionJobModifyDropzone(storeName, fieldName, idx, subFieldName) {
    return { type: MODIFY_DROPZONE, storeName, fieldName, idx, subFieldName };
}

export const CHECKBOX_CHECK = "CHECKBOX_CHECK";
export function actCheckBoxCheck(storeName, fieldName, value) {
    return { type: CHECKBOX_CHECK, storeName, fieldName, value };
}

export const CHECKBOX_UNCHECK = "CHECKBOX_UNCHECK";
export function actCheckBoxUncheck(storeName, fieldName, othersFieldName, value) {
    return { type: CHECKBOX_UNCHECK, storeName, fieldName, othersFieldName, value };
}

export const SEARCHBAR_JOB_LIST_UPDATE_BEGIN = "SEARCHBAR_JOB_LIST_UPDATE_BEGIN";
function actSearchBarJobListUpdateBegin(storeName) {
    return { type: SEARCHBAR_JOB_LIST_UPDATE_BEGIN, storeName };
}

export const SEARCHBAR_JOB_LIST_PUBLISHED_UPDATE_SUCCESS =
    "SEARCHBAR_JOB_LIST_PUBLISHED_UPDATE_SUCCESS";
function actSearchBarJobListPublishedUpdateSuccess(data, storeName) {
    return {
        type: SEARCHBAR_JOB_LIST_PUBLISHED_UPDATE_SUCCESS,
        storeName,
        data,
    };
}

export const SEARCHBAR_JOB_LIST_DRAFT_UPDATE_SUCCESS = "SEARCHBAR_JOB_LIST_DRAFT_UPDATE_SUCCESS";
function actSearchBarJobListDraftUpdateSuccess(data, storeName) {
    return {
        type: SEARCHBAR_JOB_LIST_DRAFT_UPDATE_SUCCESS,
        storeName,
        data,
    };
}

export const SEARCHBAR_JOB_LIST_UPDATE_FAIL = "SEARCHBAR_JOB_LIST_UPDATE_FAIL";
function actSearchBarJobListUpdateFail(reason) {
    return {
        type: SEARCHBAR_JOB_LIST_UPDATE_FAIL,
        reason,
    };
}

export function actSearchBarJobListUpdate(storeName, searchType, listType, keyword) {
    return dispatch => {
        dispatch(actSearchBarJobListUpdateBegin(storeName));
        return fetch(`${ApiV1Base}${ApiPrefix}/${searchType}${listType !== "draft" ? "/" : "/draft/"}search`, {
            method: "POST",
            headers: {
                Authorization: getCookie("token"),
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ keyword }),
        })
            .then(statusCheck)
            .then(json)
            .then(json => {
                if (listType === "draft") {
                    dispatch(actSearchBarJobListDraftUpdateSuccess(json, storeName));
                } else if (listType === "published") {
                    dispatch(actSearchBarJobListPublishedUpdateSuccess(json, storeName));
                }
            })
            .catch(err => {
                if (err.status === 401) {
                    dispatch(actLoginTimedOut());
                }
                dispatch(
                    actSearchBarJobListUpdateFail(typeof err === "object" ? err.message : err)
                );
            });
    };
}

export const STATE_DETAIL_CHANGE = "STATE_DETAIL_CHANGE";
export function actStateDetailChange(storeName, key, newVal) {
    return { type: STATE_DETAIL_CHANGE, storeName, key, newVal };
}
